import React, { useState, useEffect } from 'react';

const API = 'https://ster-ai-production.up.railway.app';

const ADMIN_STYLES = `
  .admin-wrap {
    display: flex;
    height: 100vh;
    background: #f7f7f7;
    font-family: 'Inter', -apple-system, sans-serif;
  }

  .admin-sidebar {
    width: 220px;
    flex-shrink: 0;
    background: #fff;
    border-right: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;
    padding: 16px 0;
  }

  .admin-sidebar-logo {
    padding: 0 16px 16px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 8px;
  }

  .admin-logo-text { font-size: 15px; font-weight: 600; color: #111; letter-spacing: -0.3px; }
  .admin-logo-sub { font-size: 11px; color: #999; margin-top: 2px; }

  .admin-nav-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px;
    cursor: pointer;
    font-size: 13px;
    color: #666;
    transition: all 0.1s;
    user-select: none;
  }

  .admin-nav-item:hover { background: #f5f5f5; color: #111; }
  .admin-nav-item.active { background: #f0f0f0; color: #111; font-weight: 500; }

  .admin-sidebar-bottom {
    margin-top: auto;
    padding: 12px 16px;
    border-top: 1px solid #e8e8e8;
  }

  .admin-user-row { display: flex; align-items: center; gap: 8px; }

  .admin-avatar {
    width: 26px; height: 26px; border-radius: 50%;
    background: #EEF2FF; display: flex; align-items: center;
    justify-content: center; font-size: 10px; font-weight: 600; color: #4F46E5;
  }

  .admin-user-name { font-size: 12px; color: #333; font-weight: 500; }

  .admin-btn-logout {
    font-size: 11px; color: #999; background: none; border: none;
    cursor: pointer; font-family: 'Inter', sans-serif; padding: 0;
  }

  .admin-btn-logout:hover { color: #333; }

  .admin-content {
    flex: 1; display: flex; flex-direction: column; overflow: hidden; min-width: 0;
  }

  .admin-topbar {
    height: 50px; border-bottom: 1px solid #e8e8e8; background: #fff;
    display: flex; align-items: center; padding: 0 24px; gap: 12px; flex-shrink: 0;
  }

  .admin-page-title { font-size: 13px; font-weight: 500; color: #111; flex: 1; }

  .admin-superadmin-badge {
    font-size: 10px; background: #5E6AD2; color: white;
    padding: 2px 8px; border-radius: 10px;
  }

  .admin-main {
    flex: 1; overflow-y: auto; padding: 24px;
  }

  .admin-section-title {
    font-size: 13px; font-weight: 600; color: #111; margin-bottom: 16px;
  }

  .admin-card {
    background: #fff; border: 1px solid #e8e8e8; border-radius: 10px;
    margin-bottom: 12px; overflow: hidden;
  }

  .admin-card-header {
    display: flex; align-items: center; padding: 14px 20px;
    cursor: pointer; gap: 10px;
  }

  .admin-card-header:hover { background: #fafafa; }

  .admin-client-name { font-size: 13px; font-weight: 500; color: #111; flex: 1; }

  .admin-client-type {
    font-size: 11px; color: #5E6AD2; background: #EEF2FF;
    padding: 2px 8px; border-radius: 10px;
  }

  .admin-card-body { padding: 0 20px 20px; border-top: 1px solid #f0f0f0; }

  .admin-field { margin-bottom: 12px; }

  .admin-label {
    display: block; font-size: 11px; font-weight: 500; color: #666;
    margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.4px;
  }

  .admin-input {
    width: 100%; padding: 8px 10px; border: 1px solid #e8e8e8;
    border-radius: 6px; font-size: 12px; font-family: 'Inter', sans-serif;
    color: #111; background: #fff; outline: none;
  }

  .admin-input:focus { border-color: #5E6AD2; }

  .admin-textarea {
    width: 100%; padding: 8px 10px; border: 1px solid #e8e8e8;
    border-radius: 6px; font-size: 12px; font-family: 'Inter', sans-serif;
    color: #111; background: #fff; outline: none; resize: vertical; min-height: 100px;
  }

  .admin-textarea:focus { border-color: #5E6AD2; }

  .admin-btn {
    font-size: 12px; padding: 6px 14px; border-radius: 6px;
    cursor: pointer; font-family: 'Inter', sans-serif; font-weight: 500;
    transition: opacity 0.1s; border: none;
  }

  .admin-btn-primary { background: #5E6AD2; color: #fff; }
  .admin-btn-primary:hover { opacity: 0.85; }

  .admin-btn-danger { background: #FEE2E2; color: #B91C1C; }
  .admin-btn-danger:hover { background: #FECACA; }

  .admin-btn-secondary {
    background: #f7f7f7; color: #111;
    border: 1px solid #e8e8e8;
  }
  .admin-btn-secondary:hover { background: #eee; }

  .admin-btn-sm { font-size: 11px; padding: 4px 10px; }

  .admin-user-list { margin-top: 12px; }

  .admin-user-row-item {
    display: flex; align-items: center; gap: 8px;
    padding: 8px 0; border-bottom: 1px solid #f5f5f5;
  }

  .admin-user-row-item:last-child { border-bottom: none; }

  .admin-user-email { font-size: 12px; color: #111; flex: 1; }

  .admin-user-role {
    font-size: 10px; padding: 2px 6px; border-radius: 10px;
    background: #f0f0f0; color: #666;
  }

  .admin-user-role.superadmin { background: #EEF2FF; color: #5E6AD2; }

  .admin-actions { display: flex; gap: 8px; margin-top: 16px; }

  .admin-divider { height: 1px; background: #f0f0f0; margin: 16px 0; }

  .admin-sub-title {
    font-size: 11px; font-weight: 600; color: #666; text-transform: uppercase;
    letter-spacing: 0.4px; margin-bottom: 10px; margin-top: 16px;
  }

  .admin-add-user-form {
    background: #f7f7f7; border-radius: 8px; padding: 14px;
    margin-top: 12px; display: grid; grid-template-columns: 1fr 1fr; gap: 8px;
  }

  .admin-add-user-form .admin-input { background: #fff; }

  .admin-export-box {
    background: #f7f7f7; border: 1px solid #e8e8e8; border-radius: 8px;
    padding: 16px; margin-bottom: 20px;
  }

  .admin-export-value {
    font-family: monospace; font-size: 10px; word-break: break-all;
    color: #333; background: #fff; border: 1px solid #e8e8e8;
    border-radius: 6px; padding: 10px; margin-top: 8px;
    max-height: 80px; overflow-y: auto;
  }

  .admin-toast {
    position: fixed; bottom: 24px; right: 24px;
    background: #111; color: #fff; font-size: 13px;
    padding: 10px 18px; border-radius: 8px;
    font-family: 'Inter', sans-serif; z-index: 1000;
    animation: fadeInAdmin 0.2s ease;
  }

  @keyframes fadeInAdmin {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .admin-new-client-form {
    background: #fff; border: 1px solid #e8e8e8; border-radius: 10px;
    padding: 20px; margin-bottom: 20px;
  }

  .admin-chevron { font-size: 12px; color: #999; transition: transform 0.1s; }
  .admin-chevron.open { transform: rotate(90deg); }

  .admin-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

  /* Toggle switch */
  .toggle-row {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 0;
  }

  .toggle-label {
    font-size: 12px; color: #111; font-weight: 500;
  }

  .toggle-sub {
    font-size: 11px; color: #999; margin-left: 2px;
  }

  .toggle-switch {
    position: relative; width: 36px; height: 20px; flex-shrink: 0;
  }

  .toggle-switch input { opacity: 0; width: 0; height: 0; }

  .toggle-slider {
    position: absolute; cursor: pointer; inset: 0;
    background: #e0e0e0; border-radius: 20px;
    transition: background 0.2s;
  }

  .toggle-slider:before {
    content: ''; position: absolute;
    width: 14px; height: 14px; left: 3px; bottom: 3px;
    background: #fff; border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.15);
  }

  .toggle-switch input:checked + .toggle-slider { background: #5E6AD2; }
  .toggle-switch input:checked + .toggle-slider:before { transform: translateX(16px); }
`;

export default function Admin({ utilisateur, onLogout, onGoBack }) {
  const [clients, setClients] = useState({});
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});
  const [editData, setEditData] = useState({});
  const [newUserData, setNewUserData] = useState({});
  const [showAddUser, setShowAddUser] = useState({});
  const [showNewClient, setShowNewClient] = useState(false);
  const [newClient, setNewClient] = useState({ id: '', nom: '', email_destinataire: '', folder_id: '', document_type: '', prompt: '', has_calendrier: false });
  const [exportB64, setExportB64] = useState('');
  const [toast, setToast] = useState(null);

  const token = utilisateur.token;
  const authHeaders = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 3000); };

  const chargerClients = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/admin/clients`, { headers: authHeaders });
      if (res.status === 401) { onLogout(); return; }
      const data = await res.json();
      setClients(data);
      const ed = {};
      Object.entries(data).forEach(([id, c]) => {
        ed[id] = {
          nom: c.nom,
          email_destinataire: c.email_destinataire,
          folder_id: c.folder_id,
          document_type: c.document_type,
          prompt: c.prompt,
          has_calendrier: c.has_calendrier || false
        };
      });
      setEditData(ed);
    } catch { showToast('Erreur de chargement'); }
    setLoading(false);
  };

  useEffect(() => { chargerClients(); }, []);

  const toggleExpand = (id) => setExpanded(e => ({ ...e, [id]: !e[id] }));

  const sauvegarderClient = async (clientId) => {
    const d = editData[clientId];
    try {
      const res = await fetch(`${API}/admin/clients/${clientId}`, {
        method: 'PUT', headers: authHeaders,
        body: JSON.stringify(d)
      });
      if (res.ok) { showToast('Client mis à jour'); chargerClients(); }
      else { const err = await res.json(); showToast(err.detail || 'Erreur'); }
    } catch { showToast('Erreur réseau'); }
  };

  const supprimerClient = async (clientId) => {
    if (!window.confirm(`Supprimer le client "${clientId}" ? Cette action est irréversible.`)) return;
    try {
      const res = await fetch(`${API}/admin/clients/${clientId}`, { method: 'DELETE', headers: authHeaders });
      if (res.ok) { showToast('Client supprimé'); chargerClients(); }
      else { const err = await res.json(); showToast(err.detail || 'Erreur'); }
    } catch { showToast('Erreur réseau'); }
  };

  const ajouterUtilisateur = async (clientId) => {
    const d = newUserData[clientId] || {};
    if (!d.email || !d.nom || !d.mot_de_passe) { showToast('Tous les champs sont requis'); return; }
    try {
      const res = await fetch(`${API}/admin/clients/${clientId}/utilisateurs`, {
        method: 'POST', headers: authHeaders,
        body: JSON.stringify({ email: d.email, nom: d.nom, mot_de_passe: d.mot_de_passe, role: d.role || 'admin' })
      });
      if (res.ok) {
        showToast('Utilisateur ajouté');
        setNewUserData(p => ({ ...p, [clientId]: {} }));
        setShowAddUser(p => ({ ...p, [clientId]: false }));
        chargerClients();
      } else { const err = await res.json(); showToast(err.detail || 'Erreur'); }
    } catch { showToast('Erreur réseau'); }
  };

  const supprimerUtilisateur = async (clientId, userEmail) => {
    if (!window.confirm(`Supprimer l'utilisateur "${userEmail}" ?`)) return;
    try {
      const res = await fetch(`${API}/admin/clients/${clientId}/utilisateurs/${encodeURIComponent(userEmail)}`, {
        method: 'DELETE', headers: authHeaders
      });
      if (res.ok) { showToast('Utilisateur supprimé'); chargerClients(); }
      else { const err = await res.json(); showToast(err.detail || 'Erreur'); }
    } catch { showToast('Erreur réseau'); }
  };

  const creerClient = async () => {
    if (!newClient.id || !newClient.nom) { showToast('ID et nom requis'); return; }
    try {
      const { id, ...data } = newClient;
      const res = await fetch(`${API}/admin/clients/${id}`, {
        method: 'POST', headers: authHeaders, body: JSON.stringify(data)
      });
      if (res.ok) {
        showToast('Client créé');
        setShowNewClient(false);
        setNewClient({ id: '', nom: '', email_destinataire: '', folder_id: '', document_type: '', prompt: '', has_calendrier: false });
        chargerClients();
      } else { const err = await res.json(); showToast(err.detail || 'Erreur'); }
    } catch { showToast('Erreur réseau'); }
  };

  const exporterBase64 = async () => {
    try {
      const res = await fetch(`${API}/admin/export`, { headers: authHeaders });
      const data = await res.json();
      setExportB64(data.clients_base64);
      await navigator.clipboard.writeText(data.clients_base64);
      showToast('CLIENTS_BASE64 copié dans le presse-papier');
    } catch { showToast('Erreur export'); }
  };

  const updateEdit = (clientId, field, value) => {
    setEditData(p => ({ ...p, [clientId]: { ...p[clientId], [field]: value } }));
  };

  const updateNewUser = (clientId, field, value) => {
    setNewUserData(p => ({ ...p, [clientId]: { ...(p[clientId] || {}), [field]: value } }));
  };

  const initiales = utilisateur.nom
    ? utilisateur.nom.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : 'SA';

  return (
    <>
      <style>{ADMIN_STYLES}</style>
      <div className="admin-wrap">
        <div className="admin-sidebar">
          <div className="admin-sidebar-logo">
            <div className="admin-logo-text">Ster-AI</div>
            <div className="admin-logo-sub">Administration</div>
          </div>

          <div className="admin-nav-item" onClick={onGoBack}>
            ← Dashboard
          </div>
          <div className="admin-nav-item active">
            Clients
          </div>

          <div className="admin-sidebar-bottom">
            <div className="admin-user-row">
              <div className="admin-avatar">{initiales}</div>
              <div>
                <div className="admin-user-name">{utilisateur.nom}</div>
                <button className="admin-btn-logout" onClick={onLogout}>Déconnexion</button>
              </div>
            </div>
          </div>
        </div>

        <div className="admin-content">
          <div className="admin-topbar">
            <div className="admin-page-title">Gestion des clients</div>
            <span className="admin-superadmin-badge">SUPERADMIN</span>
          </div>

          <div className="admin-main">

            {/* Export */}
            <div className="admin-export-box">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#111', marginBottom: 2 }}>
                    Exporter CLIENTS_BASE64
                  </div>
                  <div style={{ fontSize: 11, color: '#999' }}>
                    Après chaque modification, exporte et colle la valeur dans la variable Railway CLIENTS_BASE64
                  </div>
                </div>
                <button className="admin-btn admin-btn-primary" onClick={exporterBase64}>
                  Exporter et copier
                </button>
              </div>
              {exportB64 && (
                <div className="admin-export-value">{exportB64}</div>
              )}
            </div>

            {/* Nouveau client */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div className="admin-section-title" style={{ marginBottom: 0 }}>
                {Object.keys(clients).length} client(s)
              </div>
              <button className="admin-btn admin-btn-primary" onClick={() => setShowNewClient(v => !v)}>
                {showNewClient ? 'Annuler' : '+ Nouveau client'}
              </button>
            </div>

            {showNewClient && (
              <div className="admin-new-client-form">
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 14 }}>Nouveau client</div>
                <div className="admin-grid-2">
                  <div className="admin-field">
                    <label className="admin-label">ID client *</label>
                    <input className="admin-input" placeholder="ex: hotel_demo" value={newClient.id}
                      onChange={e => setNewClient(p => ({ ...p, id: e.target.value }))} />
                  </div>
                  <div className="admin-field">
                    <label className="admin-label">Nom *</label>
                    <input className="admin-input" placeholder="Nom affiché" value={newClient.nom}
                      onChange={e => setNewClient(p => ({ ...p, nom: e.target.value }))} />
                  </div>
                  <div className="admin-field">
                    <label className="admin-label">Email destinataire</label>
                    <input className="admin-input" placeholder="contact@client.com" value={newClient.email_destinataire}
                      onChange={e => setNewClient(p => ({ ...p, email_destinataire: e.target.value }))} />
                  </div>
                  <div className="admin-field">
                    <label className="admin-label">Folder ID Google Drive</label>
                    <input className="admin-input" placeholder="ID du dossier Drive" value={newClient.folder_id}
                      onChange={e => setNewClient(p => ({ ...p, folder_id: e.target.value }))} />
                  </div>
                  <div className="admin-field">
                    <label className="admin-label">Type de document</label>
                    <input className="admin-input" placeholder="ex: Rapports arbitrage" value={newClient.document_type}
                      onChange={e => setNewClient(p => ({ ...p, document_type: e.target.value }))} />
                  </div>
                </div>
                <div className="admin-field">
                  <label className="admin-label">Prompt IA</label>
                  <textarea className="admin-textarea" placeholder="Instructions pour l'IA..."
                    value={newClient.prompt} onChange={e => setNewClient(p => ({ ...p, prompt: e.target.value }))} />
                </div>
                <div className="toggle-row" style={{ marginBottom: 14 }}>
                  <label className="toggle-switch">
                    <input type="checkbox" checked={newClient.has_calendrier}
                      onChange={e => setNewClient(p => ({ ...p, has_calendrier: e.target.checked }))} />
                    <span className="toggle-slider" />
                  </label>
                  <span className="toggle-label">Accès Calendrier</span>
                  <span className="toggle-sub">— active l'onglet générateur de calendrier</span>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button className="admin-btn admin-btn-primary" onClick={creerClient}>Créer le client</button>
                  <button className="admin-btn admin-btn-secondary" onClick={() => setShowNewClient(false)}>Annuler</button>
                </div>
              </div>
            )}

            {/* Liste clients */}
            {loading ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#999', fontSize: 13 }}>Chargement...</div>
            ) : (
              Object.entries(clients).map(([clientId, clientData]) => (
                <div key={clientId} className="admin-card">
                  <div className="admin-card-header" onClick={() => toggleExpand(clientId)}>
                    <span className="admin-chevron" style={{ transform: expanded[clientId] ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
                    <span className="admin-client-name">{clientData.nom}</span>
                    <span style={{ fontSize: 11, color: '#999', marginRight: 8 }}>{clientId}</span>
                    <span className="admin-client-type">{clientData.document_type}</span>
                    {clientData.has_calendrier && (
                      <span style={{ fontSize: 10, background: '#DCFCE7', color: '#166534', padding: '2px 7px', borderRadius: 10, marginLeft: 4 }}>
                        Calendrier ✓
                      </span>
                    )}
                    <span style={{ marginLeft: 8, fontSize: 11, color: '#999' }}>
                      {clientData.utilisateurs?.length || 0} utilisateur(s)
                    </span>
                  </div>

                  {expanded[clientId] && (
                    <div className="admin-card-body">
                      {/* Infos client */}
                      <div className="admin-sub-title">Informations</div>
                      <div className="admin-grid-2">
                        <div className="admin-field">
                          <label className="admin-label">Nom affiché</label>
                          <input className="admin-input" value={editData[clientId]?.nom || ''}
                            onChange={e => updateEdit(clientId, 'nom', e.target.value)} />
                        </div>
                        <div className="admin-field">
                          <label className="admin-label">Email destinataire</label>
                          <input className="admin-input" value={editData[clientId]?.email_destinataire || ''}
                            onChange={e => updateEdit(clientId, 'email_destinataire', e.target.value)} />
                        </div>
                        <div className="admin-field">
                          <label className="admin-label">Folder ID Drive</label>
                          <input className="admin-input" value={editData[clientId]?.folder_id || ''}
                            onChange={e => updateEdit(clientId, 'folder_id', e.target.value)} />
                        </div>
                        <div className="admin-field">
                          <label className="admin-label">Type de document</label>
                          <input className="admin-input" value={editData[clientId]?.document_type || ''}
                            onChange={e => updateEdit(clientId, 'document_type', e.target.value)} />
                        </div>
                      </div>
                      <div className="admin-field">
                        <label className="admin-label">Prompt IA</label>
                        <textarea className="admin-textarea" value={editData[clientId]?.prompt || ''}
                          onChange={e => updateEdit(clientId, 'prompt', e.target.value)} />
                      </div>

                      {/* Toggle has_calendrier */}
                      <div className="toggle-row">
                        <label className="toggle-switch">
                          <input type="checkbox"
                            checked={editData[clientId]?.has_calendrier || false}
                            onChange={e => updateEdit(clientId, 'has_calendrier', e.target.checked)} />
                          <span className="toggle-slider" />
                        </label>
                        <span className="toggle-label">Accès Calendrier</span>
                        <span className="toggle-sub">— active l'onglet générateur de calendrier</span>
                      </div>

                      {/* Utilisateurs */}
                      <div className="admin-divider" />
                      <div className="admin-sub-title">Utilisateurs</div>

                      <div className="admin-user-list">
                        {(clientData.utilisateurs || []).map(u => (
                          <div key={u.email} className="admin-user-row-item">
                            <div className="admin-user-email">{u.email}</div>
                            <div style={{ fontSize: 11, color: '#666', marginRight: 8 }}>{u.nom}</div>
                            <span className={`admin-user-role ${u.role}`}>{u.role}</span>
                            <button className="admin-btn admin-btn-danger admin-btn-sm"
                              onClick={() => supprimerUtilisateur(clientId, u.email)}
                              style={{ marginLeft: 8 }}>
                              Supprimer
                            </button>
                          </div>
                        ))}
                        {(!clientData.utilisateurs || clientData.utilisateurs.length === 0) && (
                          <div style={{ fontSize: 12, color: '#999', padding: '8px 0' }}>Aucun utilisateur</div>
                        )}
                      </div>

                      {/* Ajouter utilisateur */}
                      {!showAddUser[clientId] ? (
                        <button className="admin-btn admin-btn-secondary admin-btn-sm"
                          style={{ marginTop: 10 }}
                          onClick={() => setShowAddUser(p => ({ ...p, [clientId]: true }))}>
                          + Ajouter un utilisateur
                        </button>
                      ) : (
                        <div className="admin-add-user-form">
                          <div className="admin-field">
                            <label className="admin-label">Email</label>
                            <input className="admin-input" placeholder="email@client.com"
                              value={newUserData[clientId]?.email || ''}
                              onChange={e => updateNewUser(clientId, 'email', e.target.value)} />
                          </div>
                          <div className="admin-field">
                            <label className="admin-label">Nom</label>
                            <input className="admin-input" placeholder="Prénom Nom"
                              value={newUserData[clientId]?.nom || ''}
                              onChange={e => updateNewUser(clientId, 'nom', e.target.value)} />
                          </div>
                          <div className="admin-field">
                            <label className="admin-label">Mot de passe</label>
                            <input className="admin-input" type="password" placeholder="Mot de passe"
                              value={newUserData[clientId]?.mot_de_passe || ''}
                              onChange={e => updateNewUser(clientId, 'mot_de_passe', e.target.value)} />
                          </div>
                          <div className="admin-field">
                            <label className="admin-label">Rôle</label>
                            <select className="admin-input"
                              value={newUserData[clientId]?.role || 'admin'}
                              onChange={e => updateNewUser(clientId, 'role', e.target.value)}>
                              <option value="admin">admin</option>
                              <option value="superadmin">superadmin</option>
                            </select>
                          </div>
                          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 8 }}>
                            <button className="admin-btn admin-btn-primary admin-btn-sm"
                              onClick={() => ajouterUtilisateur(clientId)}>
                              Ajouter
                            </button>
                            <button className="admin-btn admin-btn-secondary admin-btn-sm"
                              onClick={() => setShowAddUser(p => ({ ...p, [clientId]: false }))}>
                              Annuler
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Actions client */}
                      <div className="admin-divider" />
                      <div className="admin-actions">
                        <button className="admin-btn admin-btn-primary"
                          onClick={() => sauvegarderClient(clientId)}>
                          Sauvegarder les modifications
                        </button>
                        <button className="admin-btn admin-btn-danger"
                          onClick={() => supprimerClient(clientId)}>
                          Supprimer ce client
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      {toast && <div className="admin-toast">{toast}</div>}
    </>
  );
}